import {
  BreadcrumbProps,
  Breadcrumbs,
  Container,
  styled,
} from '@teko/ds-desktop';
import { PrintBuildPc } from '@teko/ecommerce';
import { HeadSection } from 'components/HeadSection';
import { Loading } from 'components/Loading';
import { useBuildPCV2 } from 'contexts';
import { useTenantConfig } from 'hooks';
import { t } from 'i18n';
import { PbPageProps } from 'modules/page-builder';
import dynamic from 'next/dynamic';
import React from 'react';

const PbBuildPC = dynamic(() =>
  import('../../page-builder').then((mod) => mod.PbPage),
);

export const BuildPC: React.FC<PbPageProps> = ({
  pbContent,
  pbMetaData,
  pbSSRData,
}) => {
  const { baseDomain, canonicalDomain } = useTenantConfig();
  const { loading, estimatedAmount, mappedPrintBuildPCData } = useBuildPCV2();

  const breadCrumbs: BreadcrumbProps[] = [
    {
      link: '/',
      name: t('Trang chủ'),
    },
    {
      disabled: true,
      link: '#',
      name: 'Build PC',
    },
  ];

  return (
    <>
      <Loading isLoading={loading || false}>
        <StyledContainer>
          <HeadSection
            {...(pbMetaData
              ? {
                  title: pbMetaData.metaTitle,
                  description: pbMetaData.metaDescription,
                  keywords: pbMetaData.metaKeywords?.toString(),
                  schemaPage: pbMetaData.jsonLd,
                }
              : {})}
            canonical={`${canonicalDomain || baseDomain}/buildpc`}
          />
          <Container>
            <Breadcrumbs breadcrumbs={breadCrumbs} />
          </Container>
          <PbBuildPC
            pbContent={pbContent}
            pbSSRData={pbSSRData}
            pbMetaData={pbMetaData}
            page="buildpc"
          ></PbBuildPC>
        </StyledContainer>
      </Loading>
      <PrintBuildPc
        total={estimatedAmount}
        buildpc={mappedPrintBuildPCData}
        logoProps={{ height: '60px' }}
      />
    </>
  );
};

const StyledContainer = styled(Container)`
  @media print {
    display: none;
  }
`;
